var _g, _line, _line2, _line3, _line4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFernwarme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 55,
    viewBox: "0 0 42 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1005_2061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3393 18.7808V44.2923H21.6277M5.00079 18.7808V44.2923H14.1277",
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.26233 20.9269L20.67 4.98077L40.0777 20.9269",
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58154 16.5539V8.96155H10.2392V13.5539",
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5797 26.4615C28.5797 26.4615 26.2371 24.1998 26.3308 22.7569C26.2301 21.3163 27.0423 19.9095 28.5797 18.8685C28.9476 18.6517 28.9823 18.2814 28.6491 18.0398C28.3194 17.8004 27.7503 17.7801 27.3789 17.9946C25.4561 19.2569 24.4184 20.9821 24.519 22.7569C24.4253 24.5317 27.3789 27.5147 27.3789 27.5147C27.3789 27.5147 29.7216 29.9692 29.6278 31.4121C29.725 32.8528 28.9129 34.2595 27.3789 35.3028C27.0249 35.5173 27.0006 35.8763 27.3268 36.1111C27.4934 36.2353 27.7364 36.3076 27.9932 36.3076C28.2084 36.3099 28.4166 36.2602 28.5797 36.1699C30.4955 34.9031 31.5263 33.1802 31.4291 31.4053C31.5263 29.6327 28.5797 26.4615 28.5797 26.4615Z",
    fill: "#4C4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6567 26.4615C21.6567 26.4615 19.314 24.1998 19.4078 22.7569C19.3071 21.3163 20.1192 19.9095 21.6567 18.8685C22.0246 18.6517 22.0593 18.2814 21.7261 18.0398C21.3964 17.8004 20.8272 17.7801 20.4558 17.9946C18.5331 19.2569 17.4954 20.9821 17.596 22.7569C17.5023 24.5317 20.4558 27.5147 20.4558 27.5147C20.4558 27.5147 22.7985 29.9692 22.7048 31.4121C22.802 32.8528 21.9898 34.2595 20.4558 35.3028C20.1018 35.5173 20.0775 35.8763 20.4038 36.1111C20.5704 36.2353 20.8133 36.3076 21.0702 36.3076C21.2853 36.3099 21.4936 36.2602 21.6567 36.1699C23.5725 34.9031 24.6033 33.1802 24.5061 31.4053C24.6033 29.6327 21.6567 26.4615 21.6567 26.4615Z",
    fill: "#4C4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7336 26.4615C14.7336 26.4615 12.3909 24.1998 12.4847 22.7569C12.384 21.3163 13.1961 19.9095 14.7336 18.8685C15.1015 18.6517 15.1362 18.2814 14.803 18.0398C14.4733 17.8004 13.9041 17.7801 13.5327 17.9946C11.61 19.2569 10.5723 20.9821 10.6729 22.7569C10.5792 24.5317 13.5327 27.5147 13.5327 27.5147C13.5327 27.5147 15.8754 29.9692 15.7817 31.4121C15.8789 32.8528 15.0667 34.2595 13.5327 35.3028C13.1787 35.5173 13.1544 35.8763 13.4807 36.1111C13.6473 36.2353 13.8902 36.3076 14.1471 36.3076C14.3622 36.3099 14.5705 36.2602 14.7336 36.1699C16.6494 34.9031 17.6802 33.1802 17.583 31.4053C17.6802 29.6327 14.7336 26.4615 14.7336 26.4615Z",
    fill: "#4C4B4B"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.85,
    y1: 39.85,
    x2: 20.85,
    y2: 51.15,
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20.85,
    y1: 39.85,
    x2: 20.85,
    y2: 51.15,
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 36.3547,
    y1: 51.6961,
    x2: 17.2854,
    y2: 51.6961,
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 36.3547,
    y1: 51.6961,
    x2: 17.2854,
    y2: 51.6961,
    stroke: "#4B4A4A",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1005_2061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.7769,
    height: 41.2731,
    fill: "white",
    transform: "translate(0.281555 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFernwarme);
export default __webpack_public_path__ + "static/media/IconFernwarme.2edd4a6a8e531a71855f386b97ae4792.svg";
export { ForwardRef as ReactComponent };